import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { NAV } from "@/constants/testIds";

const NAV_ITEMS = [
  { id: "work", label: "Work", href: "#work" },
  { id: "about", label: "About", href: "#about" },
  { id: "experience", label: "Experience", href: "#experience" },
  { id: "journal", label: "Journal", href: "#journal" },
];

export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();
  const onHome = location.pathname === "/";

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const handleAnchor = (e, href) => {
    if (!onHome) return; // let Link handle navigation
    e.preventDefault();
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled ? "bg-bone/90 backdrop-blur-md border-b hairline" : "bg-transparent"
      }`}
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-20 flex items-center justify-between h-20">
        <Link to="/" data-testid={NAV.logo} className="font-serif text-2xl tracking-tight">
          Justis <span className="italic text-clay">Tan</span>
        </Link>

        <nav className="hidden md:flex items-center gap-10">
          {NAV_ITEMS.map((item) =>
            onHome ? (
              <a
                key={item.id}
                href={item.href}
                data-testid={NAV.link(item.id)}
                onClick={(e) => handleAnchor(e, item.href)}
                className="text-xs uppercase tracking-[0.22em] text-ink/70 hover:text-ink link-underline transition-colors"
              >
                {item.label}
              </a>
            ) : (
              <Link
                key={item.id}
                to={`/${item.href}`}
                data-testid={NAV.link(item.id)}
                className="text-xs uppercase tracking-[0.22em] text-ink/70 hover:text-ink link-underline transition-colors"
              >
                {item.label}
              </Link>
            )
          )}
        </nav>

        {onHome ? (
          <a
            href="#contact"
            data-testid={NAV.cta}
            onClick={(e) => handleAnchor(e, "#contact")}
            className="hidden md:inline-block bg-ink text-bone px-6 py-3 text-[11px] uppercase tracking-[0.22em] hover:bg-clay transition-colors duration-300"
          >
            Commission
          </a>
        ) : (
          <Link
            to="/#contact"
            data-testid={NAV.cta}
            className="hidden md:inline-block bg-ink text-bone px-6 py-3 text-[11px] uppercase tracking-[0.22em] hover:bg-clay transition-colors duration-300"
          >
            Commission
          </Link>
        )}
      </div>
    </header>
  );
};
